import { render, staticRenderFns } from "./DataControllers.vue?vue&type=template&id=365f56b7&scoped=true&"
import script from "./DataControllers.vue?vue&type=script&lang=js&"
export * from "./DataControllers.vue?vue&type=script&lang=js&"
import style0 from "./DataControllers.vue?vue&type=style&index=0&id=365f56b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365f56b7",
  null
  
)

export default component.exports